import { render, staticRenderFns } from "./CustomQuickLinksOrder.vue?vue&type=template&id=673c73f3&scoped=true&"
import script from "./CustomQuickLinksOrder.vue?vue&type=script&lang=js&"
export * from "./CustomQuickLinksOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuickLinksOrder.vue?vue&type=style&index=0&id=673c73f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c73f3",
  null
  
)

export default component.exports